<template>
	<div :class="`${baseClass}`">
		<button
			:class="`${baseClass}-minus`"
			:disabled="locked"
			@click="$emit('sub')"
		>
			<SVGMinus/>
		</button>
		<span
			:class="`${baseClass}-value`"
			v-html="quantity"
		/>
		<button
			:class="`${baseClass}-plus`"
			:disabled="locked"
			@click="$emit('add')"
		>
			<SVGPlus/>
		</button>
	</div>
</template>

<script>
export default {
	props: {
		baseClass: String,
		quantity: Number,
		locked: Boolean,
	},
}
</script>

<style>

</style>